import { Box, Grid, Heading, Image } from '@chakra-ui/react';
import { SectionLabel } from '@denise-augusta/ui';
import { useSiteContent } from '@/providers/SiteContentProvider';
import { SiteFooter, NAV_HEIGHT } from '@/layouts/PublicLayout';
import { RichText } from '@/components/RichText';

export function About() {
  const content = useSiteContent();
  const [first, ...rest] = content.about.paragraphs;

  return (
    <Box bg="paper.warm">
      <Grid pt={NAV_HEIGHT} templateColumns={{ base: '1fr', md: '42% 1fr' }} minH={{ md: '88vh' }}>
        {/* Photo panel */}
        <Box
          bg="brand.wash"
          position="relative"
          overflow="hidden"
          display="flex"
          alignItems="center"
          justifyContent="center"
          minH={{ base: '320px', md: '500px' }}
          borderRight={{ md: '2.5px solid' }}
          borderBottom={{ base: '1px solid', md: 'none' }}
          borderColor={{ base: 'brand.pale', md: 'brand.lime' }}
          _before={{
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(ellipse at 30% 75%, rgba(61,82,168,0.10) 0%, transparent 60%)',
          }}
        >
          <Box
            position="relative"
            zIndex="1"
            w="clamp(280px, 80%, 380px)"
            aspectRatio="9/16"
            borderRadius="16px"
            overflow="hidden"
            css={{
              maskImage: 'radial-gradient(ellipse 78% 88% at 50% 50%, #000 50%, transparent 100%)',
            }}
          >
            <Image
              src="/images/denise-piano.jpg"
              alt="Denise Augusta — Virtual Administrative Assistant"
              w="100%"
              h="100%"
              objectFit="cover"
            />
          </Box>
        </Box>

        {/* Text panel */}
        <Box
          bg="paper.white"
          px={{ base: '1.8rem', md: '4.5rem' }}
          py={{ base: '3.5rem', md: '5.5rem' }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <SectionLabel display>About Me</SectionLabel>
          <Heading
            as="h1"
            fontFamily="heading"
            fontSize="clamp(2.5rem, 4.5vw, 4rem)"
            fontWeight="300"
            lineHeight="1"
            color="brand.ink"
            mb="1.8rem"
          >
            The person
            <br />
            behind the{' '}
            <Box as="em" fontStyle="italic" color="brand.mid">
              work
            </Box>
          </Heading>
          <RichText html={first ?? ''} fontSize="0.9rem" color="ink.soft" lineHeight="1.9" mb="1.1rem" />
          <Box
            borderLeft="3px solid"
            borderLeftColor="brand.mid"
            px="1.5rem"
            py="0.85rem"
            my="0.8rem"
            mb="1.8rem"
            bg="brand.wash"
            borderRadius="0 16px 16px 0"
          >
            <RichText html={content.about.pullQuote} fontFamily="heading" fontStyle="italic" fontWeight="300" fontSize="1.15rem" color="brand.ink" lineHeight="1.65" />
          </Box>
          {rest.map((paragraph) => (
            <RichText key={paragraph.slice(0, 32)} html={paragraph} fontSize="0.9rem" color="ink.soft" lineHeight="1.9" mb="1.1rem" />
          ))}
        </Box>
      </Grid>

      <SiteFooter copyright={content.footer.copyright} />
    </Box>
  );
}
